<div>
  <h1 mat-dialog-title>{{ data.title }}</h1>
  <span fxFlex></span>
  <button
    mat-icon-button
    aria-label="Chiudi"
    [mat-dialog-close]
    class="mat-dialog-close"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  {{ data.content }}
</div>
<div mat-dialog-actions>
  <span fxFlex></span>
  <button mat-raised-button color="primary" matDialogClose cdkFocusInitial>
    Ok
  </button>
</div>
